
import Vue from 'vue';
import Component from "vue-class-component";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import {EndorsementPrintTemplateModel, EndorsementPrintTemplateType, FileModel, SysAdminTemplatesClient, TemplateModel} from "@/api-client";
import {Prop} from "vue-property-decorator";
import AdministrationDetailviewLayout from "@/features/administration/AdministrationDetailviewLayout.vue";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
import toasts from "@/components/Toasts";
import {NavigationGuardNext} from "vue-router/types/router";

interface Props {
    type: EndorsementPrintTemplateType
    preloadedModel: EndorsementPrintTemplateModel;
}

@Component({
    components: {
        SectionPageHeading,
        AdministrationDetailviewLayout,
        HeadingGroup
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<EndorsementPrintTemplate>) {
        const props = to.meta!.props as Props;
        Promise.all([
            new SysAdminTemplatesClient().getEndorsementPrintTemplate(to.params.type)
        ]).then(values => {
            props.type = to.params.type as EndorsementPrintTemplateType;
            props.preloadedModel = values[0]
            console.log(props.preloadedModel)
            next();
        }).catch(e => next(e))
    }
})
export default class EndorsementPrintTemplate extends Vue implements Props {

    $refs!: {
        templateJsonContainer: HTMLPreElement;
    }

    @Prop({required: true})
    type!: EndorsementPrintTemplateType;
    @Prop({required: true})
    preloadedModel!: EndorsementPrintTemplateModel;

    template = this.preloadedModel;
}
